module.exports = __webpack_public_path__ + "static/aon-high-cost--mobile-b6c610685ef93e5140cb2cc0e72a96b0.png";